var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-header"},[_c('el-breadcrumb',{attrs:{"separator":"/"}},[_c('el-breadcrumb-item',[_vm._v("首页")]),_vm._l((_vm.breadcrumb),function(crumb,index){return _c('el-breadcrumb-item',{key:index},[_vm._v(" "+_vm._s(crumb)+" ")])})],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }